import { ComponentRef, DestroyRef, inject, Injector, TemplateRef, ViewContainerRef } from '@angular/core';
import { filter } from 'rxjs/operators';
import { DynamicComponentHelper, DynamicComponentIOCheck } from '../../../dynamic-components';
import { takeWhileAlive } from '../../../utils';
import { FeatureDynamicComponentsService } from '../feature-dynamic-components.service';
import * as i0 from "@angular/core";
import * as i1 from "../feature-dynamic-components.service";
/**
 * ReplaceableComponentDirective is a structural directive which should be used on ng-container.
 * <ng-container *replaceableComponent="{id:'selector',inputs,outputs}"></ng-container>
 * the directive will check for multiple sources in this order:
 * 1. if a component-replacement for the id was registered, render it
 * 2. if a default component for the id was registered, render it
 * 3. render the template passed as ng-content inside the container
 */
export let ReplaceableComponentDirective = /*#__PURE__*/(() => {
  class ReplaceableComponentDirective {
    set _config(config) {
      this.config = {
        inputs: {},
        outputs: {},
        IOCheck: DynamicComponentIOCheck.FilterUnknown,
        ...config
      };
    }
    constructor(templateRef, injector, vcr, dynamicComponentsService) {
      this.templateRef = templateRef;
      this.injector = injector;
      this.vcr = vcr;
      this.dynamicComponentsService = dynamicComponentsService;
      this.destroyRef = inject(DestroyRef);
      this.initialized = false;
      this.defaultComponentContext = {};
      this.componentBindings = [];
    }
    ngOnInit() {
      this.dynamicComponentsService.resolveComponent(this.config.id).pipe(filter(componentInfo => {
        if (!this.initialized) {
          return true;
          // TODO: implement better comparison
        } else if (componentInfo && componentInfo.component !== this.componentInfo?.component) {
          return true;
        }
      }),
      // distinctUntilChanged(),
      takeWhileAlive(this.destroyRef)).subscribe(componentInfo => {
        if (componentInfo.component) {
          this.componentInfo = componentInfo;
          this.setupCustomComponent(componentInfo);
        } else {
          this.componentInfo = null;
          this.vcr.createEmbeddedView(this.templateRef);
        }
      });
    }
    clearBindings() {
      this.componentBindings.forEach(binding => binding.next(true));
      this.componentBindings = [];
    }
    setupCustomComponent(componentInfo) {
      const config = {
        component: componentInfo,
        ...this.config
      };
      this.clearBindings();
      const {
        componentRef,
        destroyBindings
      } = DynamicComponentHelper.makeCustomComponent(config, this.injector, this.vcr, this.componentRef);
      this.componentBindings.push(destroyBindings);
      this.componentRef = componentRef;
      this.initialized = true;
    }
    static {
      this.ɵfac = function ReplaceableComponentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ReplaceableComponentDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1.FeatureDynamicComponentsService));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: ReplaceableComponentDirective,
        selectors: [["", "replaceableComponent", ""]],
        inputs: {
          _config: [0, "replaceableComponent", "_config"]
        },
        features: [i0.ɵɵProvidersFeature([])]
      });
    }
  }
  return ReplaceableComponentDirective;
})();